import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IAuthAction,
  IAuthResponse,
  IResetAction,
  ISystemAction,
  IValidateAction,
  IValidateResponse,
  IGoogleAuthAction,
  ISignUpAction,
} from 'types/session/auth';
import { AxiosWrapper } from './axios.wrapper';
import { PasswordType } from 'app/components/Password';

export const validationRequest = createAsyncThunk('validate', async (data: IValidateAction) => {
  const response = await AxiosWrapper.post('/auth/validate', data);
  return response.data as IValidateResponse;
});

export const authRequest = createAsyncThunk('auth', async (data: IAuthAction) => {
  const response = await AxiosWrapper.post('/auth', data);
  return response.data as IAuthResponse;
});

export const authGoogleRequest = createAsyncThunk('auth/google/signin', async (data: IGoogleAuthAction) => {
  const response = await AxiosWrapper.post('/auth/google/signin', data);
  return response.data as IAuthResponse;
});

export const signUpRequest = createAsyncThunk('signup', async (data: Partial<ISignUpAction>) => {
  const response = await AxiosWrapper.post('/auth/signup', data);
  return response.data as IAuthResponse;
});

export const emailValidateRquest = createAsyncThunk('email/validate', async (data: { token: string }) => {
  const response = await AxiosWrapper.post('/auth/email/validate', data);
  return response.data as string;
});

export const forgotRequest = createAsyncThunk('password/forgot', async (data: Partial<IResetAction>) => {
  const response = await AxiosWrapper.post('/auth/forgot', data);
  return response.data as IAuthResponse;
});

export const passwordRequest = createAsyncThunk('password/set', async (data: Partial<IResetAction>) => {
  const response = await AxiosWrapper.post(
    data.type === PasswordType.SETUP ? '/auth/signup/password' : '/auth/reset',
    data,
  );
  return response.data as IAuthResponse;
});

export const domainRequest = createAsyncThunk(
  '/auth/signup/organisation',
  async (data: { name: string; domain: string }) => {
    const response = await AxiosWrapper.post('/auth/signup/organisation', data);
    return response.data as IAuthResponse;
  },
);

export const systemSigninRequest = createAsyncThunk('system/signin', async (data: ISystemAction) => {
  const response = await AxiosWrapper.post('/auth/system/signin', data);
  return response.data as IAuthResponse;
});
export const newSigninRequest = createAsyncThunk('new/signin', async (data: { token: string }) => {
  const response = await AxiosWrapper.post('/auth/signin/new/token', data);
  return response.data as IAuthResponse;
});
